import { GlobalOutlined } from "@ant-design/icons";
import { Dropdown, Space, Typography } from "antd";
import { getLocale } from "@airange/shared/i18n-ctf-admin";
import { useIntl } from "@umijs/max";
import { ctfAdminLocaleController } from "../lib/locale";

const localeItems = [
  { key: "zh-CN", labelMessageId: "ctf.locale.zhCN" },
  { key: "en", labelMessageId: "ctf.locale.en" },
  { key: "ja", labelMessageId: "ctf.locale.ja" },
];

export function LocaleSwitch() {
  const intl = useIntl();
  const currentLocale = getLocale();
  const currentLabel =
    localeItems.find((item) => item.key === currentLocale)?.labelMessageId ?? "ctf.locale.zhCN";
  return (
    <Dropdown
      menu={{
        items: localeItems.map((item) => ({
          key: item.key,
          label: intl.formatMessage({ id: item.labelMessageId }),
        })),
        onClick: ({ key }) => {
          ctfAdminLocaleController.switchLocale(String(key));
        },
        selectable: true,
        selectedKeys: [currentLocale],
      }}
      trigger={["click"]}
    >
      <Typography.Link>
        <Space size={6}>
          <GlobalOutlined />
          <span>{intl.formatMessage({ id: currentLabel })}</span>
        </Space>
      </Typography.Link>
    </Dropdown>
  );
}
